var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleBlackDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8488_2813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3649 9.0003C11.3874 11.4216 13.4882 12.2274 13.5115 12.2376C13.4937 12.2944 13.1758 13.3859 12.4047 14.5133C11.738 15.488 11.0462 16.4591 9.95625 16.4792C8.88531 16.4989 8.54094 15.8439 7.31655 15.8439C6.09253 15.8439 5.70993 16.4591 4.69616 16.4989C3.64412 16.5388 2.84298 15.445 2.17084 14.4738C0.797343 12.4874 -0.252293 8.86062 1.1571 6.41249C1.85726 5.19673 3.1085 4.42687 4.4666 4.40713C5.49967 4.38741 6.47474 5.1024 7.1063 5.1024C7.73746 5.1024 8.92238 4.24257 10.1681 4.36884C10.6896 4.39056 12.1534 4.57957 13.0934 5.95595C13.0176 6.00291 11.3467 6.976 11.3649 9.0003ZM9.35217 3.05464C9.9107 2.37831 10.2866 1.4368 10.1841 0.5C9.37898 0.532369 8.40546 1.03668 7.82799 1.71264C7.31047 2.31123 6.85724 3.26931 6.97953 4.18757C7.87688 4.25702 8.79361 3.7314 9.35217 3.05464Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8488_2813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.0256,
    height: 16,
    fill: "white",
    transform: "translate(0.487061 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleBlackDark);
export default __webpack_public_path__ + "static/media/apple-black-dark.a550c93be76ac5f7cba873542972bc92.svg";
export { ForwardRef as ReactComponent };